var announcements = document.querySelectorAll('#announcements .announcement');

if(announcements.length > 1) {
	var autoSlideAnnouncements = function() {
			slideAnnouncement();
		},
		announcementsIntervalID = setInterval(autoSlideAnnouncements, 15000);

	[].slice.call(topbar.querySelectorAll('.controller button')).forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(announcementsIntervalID);

			if(this.classList.contains('next')) {
				slideAnnouncement();

				if(this.previousSibling.classList.contains('pause'))
					announcementsIntervalID = setInterval(autoSlideAnnouncements, 15000);
			}
			else {
				var isPlay = this.classList.contains('play');

				if(isPlay)
					announcementsIntervalID = setInterval(autoSlideAnnouncements, 15000);

				this.className = isPlay ? 'pause' : 'play';
				this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Announcements');
			}
		});
	});
}

function slideAnnouncement() {
	var current = document.querySelector('#announcements .current'),
		sibling = current == announcements[announcements.length-1] ? announcements[0] : current.nextSibling;

	current.classList.add('hide');

	setTimeout(function() {
		current.classList.remove('current', 'next', 'hide');
		sibling.classList.add('current', 'next');
	}, 550);
}